// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

/**
 * TODO: find out why this cannot be namespaced under file?
 */
export enum FileDownloadSourceApplicationBuf {
  Website = 0,
  AgentReadWebsite = 1
}
